var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "footer",
    [
      _c("router-link", { attrs: { to: "/datenschutz" } }, [
        _vm._v("Datenschutz"),
      ]),
      _c("router-link", { attrs: { to: "/impressum" } }, [_vm._v("Impressum")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }